export default __webpack_public_path__ + "static/media/img-0311-madagascar-full-face.08ee891f.png";